<div
	class="content"
	style="min-height: 600px"
>
	<section class="modifica">
		<fieldset>
			<div class="form-modifica">
				<div class="field read col-sm-6">
					<span>
						<b>{{ "myLot.vehiclesBooked" | translate }}:</b>
					</span>
					<br />
					<span>{{ myLotFull?.myLotStat?.vehiclesBooked }}</span>
				</div>
				<div class="field read col-sm-3">
					<span>
						<b>{{ "myLot.vehiclesPreemption" | translate }}:</b>
					</span>
					<br />
					<span>{{ myLotFull?.myLotStat?.vehiclesPreemption }}</span>
				</div>

				<div class="field read col-sm-6">
					<span>
						<b>{{ "myLot.lotSize" | translate }}:</b>
					</span>
					<br />
					<span>{{ myLotFull?.myLotDTO?.vehicles?.length }}</span>
				</div>
				<div class="field read col-sm-6">
					<span>
						<b>{{ "myLot.mediaMix" | translate }}:</b>
					</span>
					<br />
					<span>{{ Math.floor(myLotFull?.myLotDTO?.mediaMix) }}</span>
				</div>

				<div class="field read col-sm-6">
					<span>
						<b>{{ "myLot.totalLotCost" | translate }}:</b>
					</span>
					<br />
					<span>{{ Math.floor(myLotFull?.myLotDTO?.totalCost) }}</span>
				</div>
				<div class="field read col-sm-6">
					<span>
						<b>{{ "myLot.totalLotCostDiscount" | translate }}:</b>
					</span>
					<br />
					<span>{{ Math.floor(myLotFull?.myLotDTO?.totalCostWithDiscount) }}</span>
				</div>
			</div>
		</fieldset>

		<section class="catalogo-aste">
			@if (vehicles?.length) {
				<div class="rich-table-container">
					<!-- floatthead -->
					<table
						class="table table-striped rich-table tabella"
						[mfData]="vehicles"
						#mf="appDataTable"
						[mfRowsOnPage]="tableData.rowsOnPage"
						[(mfSortBy)]="tableData.orderBy"
						[(mfSortOrder)]="tableData.sortOrder"
					>
						<thead class="rich-table-thead">
							<tr class="rich-table-subheader">
								<th
									class="rich-table-subheadercell"
									scope="col"
								></th>
								<th
									class="rich-table-subheadercell"
									scope="col"
								>
									{{ "showcase.catalogue.preview" | translate }}
								</th>
								<th
									class="rich-table-subheadercell"
									scope="col"
								>
									<app-default-sorter by="licensePlate">
										{{ "showcase.catalogue.licensePlate" | translate }}
									</app-default-sorter>
								</th>
								<th
									class="rich-table-subheadercell"
									scope="col"
								>
									<app-default-sorter by="frame">
										{{ "showcase.catalogue.frame" | translate }}
									</app-default-sorter>
								</th>
								<th
									class="rich-table-subheadercell"
									scope="col"
								>
									<app-default-sorter by="price">
										{{ "showcase.catalogue.price" | translate }}
									</app-default-sorter>
								</th>
								<th
									class="rich-table-subheadercell"
									scope="col"
								>
									<app-default-sorter by="brand">
										{{ "showcase.catalogue.description" | translate }}
									</app-default-sorter>
								</th>
								<th
									class="rich-table-subheadercell"
									scope="col"
								>
									<app-default-sorter by="yearMatriculation">
										{{ "showcase.catalogue.monthMatriculation" | translate }}
									</app-default-sorter>
								</th>
								<th
									class="rich-table-subheadercell"
									scope="col"
								>
									<app-default-sorter by="kilometers">
										{{ "showcase.catalogue.kilometers" | translate }}
									</app-default-sorter>
								</th>
								<th
									class="rich-table-subheadercell"
									scope="col"
								>
									<app-default-sorter by="damaged">
										{{ "showcase.catalogue.damaged" | translate }}
									</app-default-sorter>
								</th>
								<th
									class="rich-table-subheadercell"
									scope="col"
								>
									<app-default-sorter by="area">
										{{ "showcase.catalogue.area" | translate }}
									</app-default-sorter>
								</th>
								<th
									class="rich-table-subheadercell"
									scope="col"
								>
									<app-default-sorter by="mix">
										{{ "showcase.catalogue.mix" | translate }}
									</app-default-sorter>
								</th>
							</tr>
						</thead>
						<tbody>
							@for (element of mf.data; track element) {
								<tr class="rich-table-row rich-table-firstrow altclr">
									<td class="rich-table-cell text-center">
										<input
											type="checkbox"
											[(ngModel)]="element.selected"
										/>
									</td>
									<td
										class="rich-table-cell text-center"
										(click)="vehicleDetails(element.idVehicle)"
									>
										@if (utils.isEmpty(element?.appraisalCode)) {
											@if (utils.isEmpty(element?.idPrincipalPhoto)) {
												<img
													style="max-height: 80px; max-width: 80px"
													[src]="wcmService.noPhotoUrl"
												/>
											} @else {
												<img
													style="max-height: 80px; max-width: 80px"
													[src]="utils.getImageUrl(element?.idPrincipalPhoto)"
												/>
											}
										} @else {
											<img
												style="max-height: 80px; max-width: 80px"
												[src]="element?.imageUrl || wcmService.noPhotoUrl"
											/>
										}
									</td>
									<td class="rich-table-cell text-center">{{ element?.licensePlate == -1 ? ("vehicle.notAvailable" | translate) : element.licensePlate }}</td>
									<td class="rich-table-cell text-center">{{ element?.frame }}</td>
									<td class="rich-table-cell text-center">{{ Math.floor(element?.price) }}</td>
									<td class="rich-table-cell text-center">
										<a
											class="link"
											[routerLink]="['/private/vehicle-management/vehicle-details', { idVehicle: element?.idVehicle }]"
										>
											{{ element?.brand }} {{ element?.model }}
										</a>
									</td>
									<td class="rich-table-cell text-center">{{ element?.monthMatriculation }}/{{ element?.yearMatriculation }}</td>
									<td class="rich-table-cell text-center">{{ element?.kilometers == -1 ? ("vehicle.notAvailable" | translate) : element.kilometers }}</td>
									<td class="rich-table-cell text-center">{{ element?.damaged == -1 ? ("vehicle.notAvailable" | translate) : Math.floor(element?.damaged) }}</td>
									<td class="rich-table-cell text-center">{{ element?.locateArea }}</td>
									<td class="rich-table-cell text-center">{{ element?.mix }}</td>
								</tr>
							}
						</tbody>
						<tfoot>
							<tr>
								<td [attr.colspan]="tableData.col">
									<app-bootstrap-paginator [rowsOnPageSet]="rowsOnPageSet"></app-bootstrap-paginator>
								</td>
							</tr>
						</tfoot>
					</table>
				</div>
				<div class="col-sm-12 text-center">
					<div class="col-sm-4 text-center">
						<span>
							<a
								[class.disabled]="removeDisabled()"
								(click)="removeSelected()"
								class="btn btn-red"
							>
								{{ "myLot.button.removeSelected" | translate }}
							</a>
						</span>
					</div>
				</div>
			} @else {
				<div>
					<h2>{{ "myLot.noVehicleInLot" | translate }}</h2>
				</div>
			}

			@if (!utils.isEmpty(vehicles)) {
				<div class="col-sm-12">
					<label for="message">{{ "myLot.message" | translate }}</label>
					<textarea
						style="min-height: 80px; max-height: 80px; width: 100%"
						id="message"
						name="message"
						[(ngModel)]="message"
					></textarea>
				</div>
			}

			<div class="col-sm-12 text-center">
				<span>
					<span>
						<a
							(click)="location.back()"
							class="btn btn-grey"
						>
							{{ "myLot.button.back" | translate }}
						</a>
					</span>
					@if (!utils.isEmpty(vehicles)) {
						<span>
							<a
								[class.disabled]="removeDisabled()"
								(click)="bookLot()"
								class="btn btn-red"
							>
								{{ "myLot.button.book" | translate }}
							</a>
						</span>
					}
				</span>
			</div>
		</section>
	</section>
</div>